
<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
              <span>Cancelar factura</span>
          </h4>
        </template>


        <div class="con-form">
            <h6>Para poder cambiar el nombre del concepto, deberá cancelar la factura existente de <strong>{{row.concepto}}</strong>.</h6>
            <h5>¿Quiere cancelar la factura?</h5>
        </div>

        <template #footer>
          <div class="footer-dialog" style="display:flex; justify-content: space-between">  
            <vs-button style="width: 30%" block danger class="color-red" @click="active = false">
              Cancelar
            </vs-button>
            <vs-button style="width: 30%" block success @click="abrirCancelar()">
              Aceptar
            </vs-button>        
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import cobranza from '../../../../api/requests/cobranza-persona'
    export default {
        props:[
          'value',
          'row',
          'institucion'
        ],
        data:() => ({
            active: false,
            concepto: '',
        }),
        methods:{
          abrirCancelar(){
            this.$emit('abrirModal');
            this.active = false
          },
          async getCancelarFactura(){
              const loading = this.$vs.loading()
              try { 
                  const response = await cobranza.getCancelFactura(this.row.factura.uuid, this.institucion)
                  if(response.status === 200) {
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',                           
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'La factura ha sido cancelada'
                    })
                    this.$emit('changeConcepto', this.row);
                    loading.close()
                  }
              } catch (error) {
                    loading.close()
                  this.$vs.notification({
                      progress: 'auto',
                      color: 'danger',
                      position: null,
                      title: 'Error',
                      text: error.response.data.message
                  })
              }
          },
        },
        watch: {
            value (val) {
                this.active = val
            },
            active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
        }
    }
</script>
